import styled from '@emotion/styled';
import Dialog from '../dialog/dialog'; // Assuming Dialog is in ../dialog/dialog
import { gutterSizes } from '../base/theme'; // Assuming theme is in ../base/theme

export const StyledModalDialog = styled(Dialog)`
    max-width: unset;
`;

export const MapsContainer = styled.div`
    padding-top: ${gutterSizes.xxlarge};
`;
